












































































import Vue from 'vue';
import { mapState } from 'vuex';
import {
  Component, Inject,
} from 'vue-property-decorator';
import {
  Alert,
  NoticeClass,
  AuthStore,
} from '@kasasa/fbase-components/lib';
import { KCardHeader } from '@kasasa/fbase-components';
import DisclaimerFooter from '@/components/DisclaimerFooter.vue';
import QuestionCard from '@/components/QuestionCard.vue';
import { StringMap } from '@/api/i18n/';
import { Graph } from '@/api/graph/';
import { Settings } from '@/api/settings/';
import { AnswerMap } from '@/api/AnswerMap';
import AnswerSummary from '@/components/AnswerSummary.vue';
import { DocumentResource, PersistedAnswers } from '@/api/document/';


@Component({
  computed: mapState(['fiId', 'graphMap', 'fiSettings', 'auth', 'stringMap']),
  components: {
    DisclaimerFooter, QuestionCard, AnswerSummary, KCardHeader,
  },
})
export default class CycleDatesView extends Vue {
  fiId!: string;

  graphMap!: Map<string, Graph>;

  fiSettings!: Settings;

  auth!: AuthStore;

  stringMap!: StringMap;

  saving: boolean = false;

  accepted: boolean = false;

  @Inject('DocumentResource')
  documentResource!: DocumentResource;

  headerItems: any = [
    {
      text: 'RegGen',
      disabled: false,
      link: false,
    },
    {
      text: 'Cycle Dates',
      disabled: true,
    },
  ];

  onDownload() {
    let answers:AnswerMap | null = null;
    try {
      answers = this.buildAnswersForGeneration();
    } catch (error) {
      this.showErrorMessage(error);
      this.saving = false;
    }

    if (answers) {
      this.documentResource.createDocument(this.fiId, {
        answers, friendlyAnswers: [], userName: this.getLoggedInUserFullName(), email: this.auth!.sessionData!.email,
      }).then((result:PersistedAnswers) => {
        window.location.href = `/api/document/${result.id}`;
      }).catch((error) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.saving = false;
      });
    }
  }

  getLoggedInUserFullName(): string {
    let name: string = '';

    if (this.auth?.sessionData?.firstName && this.auth.sessionData.firstName.length > 0) {
      name = `${this.auth.sessionData.firstName} `;
    }

    if (this.auth?.sessionData?.lastName && this.auth.sessionData.lastName.length > 0) {
      name += this.auth.sessionData.lastName;
    }

    return name;
  }


  buildAnswersForGeneration() : AnswerMap {
    const setupGraph:Graph | undefined = this.graphMap.get('settings');

    if (!setupGraph) {
      throw new Error('Unable to find setup question graph!');
    }

    const mdgGraph:Graph | undefined = this.graphMap.get('mdg');

    if (!mdgGraph) {
      throw new Error('Unable to find mdg question graph!');
    }

    let answers: AnswerMap = {};
    // set defaults
    if (mdgGraph.defaults) {
      Object.assign(answers, mdgGraph.defaults);
    }

    answers = { ...answers, ...setupGraph!.buildAnswersForGeneration(this.fiSettings.attributes) };
    answers.documentType = 'CYCLES';

    return answers;
  }


  showErrorMessage(error: any) {
    console.error(error);
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
